"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelToolManager = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const getLabelPosition_1 = require("../../components/utils/getLabelPosition");
class LabelToolManager {
    constructor(store, bridge) {
        this.store = store;
        this.bridge = bridge;
    }
    selectLabel(labelID, openModelPart) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const state = this.store.getState();
            const { labels, selectedLabelID } = state.labelsState;
            if (labelID === selectedLabelID) {
                return;
            }
            const label = labels.find(l => l.identifier === labelID);
            if (!label) {
                return;
            }
            if (label.type !== bridge_schema_1.LabelType.Group) {
                yield this.bridge.selectLabel({
                    labelType: label.type,
                    mvMatrix: JSON.parse(label.modelPosition),
                    object: {
                        identifier: ((_a = label.object) === null || _a === void 0 ? void 0 : _a.identifier) || '',
                    },
                    isModelPartInfo: openModelPart,
                });
            }
            else {
                const objectList = ((_b = label.parts) === null || _b === void 0 ? void 0 : _b.map(part => ({
                    identifier: part.object.identifier,
                }))) || [];
                yield ((_c = this.bridge) === null || _c === void 0 ? void 0 : _c.selectLabel({
                    labelType: bridge_schema_1.LabelType.Group,
                    moveModel: true,
                    mvMatrix: JSON.parse(label === null || label === void 0 ? void 0 : label.modelPosition),
                    objectList: objectList,
                    isModelPartInfo: openModelPart,
                }));
            }
            this.store.dispatch({
                type: 'toolsState/BridgeObjectChanged',
                payload: {
                    identifier: 'toolsState',
                    keyPath: 'labelsState.selectedLabelID',
                    changes: labelID,
                },
            });
        });
    }
    selectPart(labelID, partID) {
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.selectedLabelID',
                changes: labelID,
            },
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.selectedLabelPartID',
                changes: partID,
            },
        });
    }
    deselectLabel() {
        var _a;
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.selectedLabelID',
                changes: '',
            },
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.selectedLabelPartID',
                changes: '',
            },
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.latestLabel',
                changes: undefined,
            },
        });
        (_a = this.bridge) === null || _a === void 0 ? void 0 : _a.labelsDeselect();
    }
    deselectPart() {
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.selectedLabelPartID',
                changes: '',
            },
        });
    }
    addLabel(newLabel) {
        var _a;
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return null;
        }
        const screenWidth = document.body.offsetWidth;
        const screenHeight = document.body.offsetHeight;
        const labelToAdd = Object.assign(Object.assign({}, newLabel), { screenSize: [screenWidth, screenHeight] });
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { labels: [...(((_a = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === null || _a === void 0 ? void 0 : _a.labels) || []), labelToAdd] });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
        return labelToAdd;
    }
    updateLabels(labels) {
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.labels',
                changes: labels,
            },
        });
    }
    updateLabelTarget(identifier, newTarget) {
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const label = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels.find(l => l.identifier === identifier);
        if (!label ||
            (label.target.x === newTarget[0] && label.target.y === newTarget[1])) {
            return;
        }
        const updatedLabels = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels.map(l => {
            if (l.identifier === identifier) {
                return Object.assign(Object.assign({}, l), { target: { x: newTarget[0], y: newTarget[1] } });
            }
            return l;
        });
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { labels: updatedLabels });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
    updateLabelPartsTarget(identifier, targets) {
        var _a;
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const labelIndex = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels.findIndex(l => l.identifier === identifier);
        if (labelIndex === undefined) {
            return;
        }
        const label = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels[labelIndex];
        if (!label) {
            return;
        }
        const parts = (_a = label.parts) === null || _a === void 0 ? void 0 : _a.map(part => {
            const updatedTarget = targets.find(target => target.identifier === part.object.identifier);
            if (!updatedTarget) {
                return part;
            }
            return Object.assign(Object.assign({}, part), { target: {
                    x: updatedTarget.target[0] / window.innerWidth,
                    y: updatedTarget.target[1] / window.innerHeight,
                } });
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: `labelsState.labels.${labelIndex}.parts`,
                changes: parts,
            },
        });
    }
    updateLabelPosition(identifier, newPosition) {
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const updatedLabels = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels.map(label => {
            if (label.identifier === identifier) {
                return Object.assign(Object.assign({}, label), { position: newPosition });
            }
            return label;
        });
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { labels: updatedLabels });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
    removeLabel(identifier) {
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const updatedLabels = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels.filter(label => label.identifier !== identifier);
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { labels: updatedLabels, latestLabel: undefined, isGroupMode: false });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
    setGroupMode() {
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { isGroupMode: true });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
    resetGroupMode() {
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { isGroupMode: false });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
    updateLabelText(identifier, newText) {
        const currentState = this.store.getState();
        if (currentState && (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const updatedLabels = currentState === null || currentState === void 0 ? void 0 : currentState.labelsState.labels.map(label => {
            if (label.identifier === identifier) {
                return Object.assign(Object.assign({}, label), { text: newText });
            }
            return label;
        });
        const newLabelsState = Object.assign(Object.assign({}, currentState === null || currentState === void 0 ? void 0 : currentState.labelsState), { labels: updatedLabels });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
    getLabelsState() {
        var _a;
        const state = this.store.getState();
        if (!(state === null || state === void 0 ? void 0 : state.labelsState)) {
            return [];
        }
        const labels = (_a = state.labelsState.labels) !== null && _a !== void 0 ? _a : [];
        return labels.map(label => {
            var _a, _b, _c;
            const position = [label.target.x, label.target.y];
            const translate = [label.position.x, label.position.y];
            switch (label.type) {
                case bridge_schema_1.LabelType.Default:
                case bridge_schema_1.LabelType.Custom:
                    return {
                        identifier: label.identifier,
                        pos: position,
                        translate: translate,
                        id: (_a = label.object) === null || _a === void 0 ? void 0 : _a.identifier,
                        system_id: (_b = label.object) === null || _b === void 0 ? void 0 : _b.systemId,
                        labelType: label.type,
                        savedWindowSize: label.screenSize,
                        text: label.text,
                        mvMatrix: JSON.parse(label.modelPosition),
                        pos3D: label.position3D,
                    };
                case bridge_schema_1.LabelType.Group:
                    return {
                        identifier: label.identifier,
                        pos: position,
                        translate: translate,
                        labelType: label.type,
                        text: label.text,
                        mvMatrix: JSON.parse(label.modelPosition),
                        savedWindowSize: label.screenSize,
                        pos3D: label.position3D,
                        targetObjects: (_c = label.parts) === null || _c === void 0 ? void 0 : _c.map(part => {
                            return {
                                objects: [
                                    {
                                        id: part.object.identifier,
                                        position: [part.target.x, part.target.y],
                                        system_id: part.object.systemId,
                                        pos3D: part.position3D,
                                        selected: state.labelsState.selectedLabelPartID ===
                                            part.object.identifier,
                                    },
                                ],
                            };
                        }),
                    };
            }
        });
    }
    setLabelsState(state) {
        const screenWidth = document.body.offsetWidth;
        const screenHeight = document.body.offsetHeight;
        const labels = state.map((label) => {
            var _a, _b, _c, _d;
            const xRatio = 1 / screenWidth;
            const yRatio = 1 / screenHeight;
            const orientation = label.labelType === bridge_schema_1.ToolType.LabelsRight
                ? bridge_schema_1.LabelOrientation.Right
                : bridge_schema_1.LabelOrientation.Left;
            const defaultPosition = (0, getLabelPosition_1.getLabelPosition)({
                x: label.position[0],
                y: label.position[1],
            }, orientation, 280, { width: screenWidth, height: screenHeight });
            return {
                identifier: (_a = label.identifier) !== null && _a !== void 0 ? _a : Math.round(Math.random() * 10e6).toString(), //NOSONAR
                type: label.labelType,
                position: label.translate
                    ? {
                        x: label.translate[0] < 1
                            ? label.translate[0]
                            : label.translate[0] * xRatio,
                        y: label.translate[1] < 1
                            ? label.translate[1]
                            : label.translate[1] * yRatio,
                    }
                    : defaultPosition,
                target: {
                    x: label.position[0],
                    y: label.position[1],
                },
                screenSize: label.savedWindowSize,
                modelPosition: JSON.stringify(label.mvMatrix),
                text: label.text,
                // @ts-ignore
                object: Object.assign({ identifier: label.id, systemId: label.system_id }, ((_b = label.object) !== null && _b !== void 0 ? _b : {})),
                position3D: (_c = label.pos3D) !== null && _c !== void 0 ? _c : label.position3D,
                orientation,
                parts: (_d = label.targetObjects) === null || _d === void 0 ? void 0 : _d.map((part) => {
                    var _a, _b, _c;
                    return {
                        object: {
                            identifier: (_a = part.id) !== null && _a !== void 0 ? _a : part.identifier,
                            systemId: (_b = part.system_id) !== null && _b !== void 0 ? _b : part.systemId,
                            latinName: part.latinName,
                            name: part.name,
                        },
                        target: {
                            x: part.position[0] < 1
                                ? part.position[0]
                                : part.position[0] * xRatio,
                            y: part.position[1] < 1
                                ? part.position[1]
                                : part.position[1] * yRatio,
                        },
                        position3D: (_c = part.pos3D) !== null && _c !== void 0 ? _c : part.position3D,
                    };
                }),
            };
        });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.labels',
                changes: labels,
            },
        });
    }
    clearLastAddedLabel() {
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState.latestLabel',
                changes: null,
            },
        });
    }
    updateUndoRedoHistory() {
        var _a;
        (_a = this.bridge) === null || _a === void 0 ? void 0 : _a.addActionToHistory({
            state: {
                labelManagerState: this.getLabelsState(),
            },
        });
    }
    removePartFromGroupLabel(labelIdentifier, partIdentifier) {
        const currentState = this.store.getState();
        if (!currentState || (currentState === null || currentState === void 0 ? void 0 : currentState.labelsState) === undefined) {
            return;
        }
        const updatedLabels = currentState.labelsState.labels.map(label => {
            var _a;
            if (label.identifier === labelIdentifier &&
                label.type === bridge_schema_1.LabelType.Group) {
                return Object.assign(Object.assign({}, label), { parts: (_a = label.parts) === null || _a === void 0 ? void 0 : _a.filter(part => part.object.identifier !== partIdentifier) });
            }
            return label;
        });
        const newLabelsState = Object.assign(Object.assign({}, currentState.labelsState), { labels: updatedLabels });
        this.store.dispatch({
            type: 'toolsState/BridgeObjectChanged',
            payload: {
                identifier: 'toolsState',
                keyPath: 'labelsState',
                changes: newLabelsState,
            },
        });
    }
}
exports.LabelToolManager = LabelToolManager;
